import { createTheme } from '@material-ui/core/styles'

export const COLORS = {
  blue: '#007bff',
  darkBlue: '#31708f',
  green: '#16a2b8',
  emerald: '#00cccc',
  red: '#ee5b5b',
  yellow: '#fcd53b',
  dark: '#001737',
  gray: '#d8d8d8',
  grayLighter: '#e6e6e6',
  grayExtraLighter: '#f0f0f0',
}

export const ELEMENTS = {
  hover: COLORS.grayExtraLighter,
  border: COLORS.grayLighter,
}

export default createTheme({
  palette: {
    primary: {
      main: COLORS.blue,
    },
    secondary: {
      main: COLORS.red,
    },
  },
})
